import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { DEFAULT_ROUTE } from "../../../routes/api/api_routes";
import Loader from "../../../utils/Loader";
import { store } from "../../../redux/store/store";
import {
  setLoginSucess,
  setAuthenticatedSuccess,
  setUserLoadSuccess,
} from "../../../redux/reducers/auth";
import {
  ACCUEIL_PATH,
  COACH_DASHBOARD_PATH,
  ADMIN_DASHBOARD_PATH,
} from "../../../routes/navigation/navigation_paths";
import { toast } from "react-toastify";
import { setToken, setCurrentUser } from "../../../utils/auth";

const BakeliCallback = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = store.dispatch;
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    // Récupère le code/state depuis l'URL et valide côté backend
    fetch(`${DEFAULT_ROUTE}auth/callback/${location.search}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      // credentials: "include",
    })
      .then(async (response) => {
        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(body?.message || "Callback SSO invalide");
        }
        return body;
      })
      .then((payload) => {
        setData(payload);
        if (payload.token && payload.user) {
          setToken(payload.token);
          dispatch(setLoginSucess({ access: payload.token, refresh: payload.refresh }));
          dispatch(setAuthenticatedSuccess());
          dispatch(setUserLoadSuccess(payload.user));
          setCurrentUser(payload.user);

          if (payload.user.is_coach) {
            navigate(COACH_DASHBOARD_PATH, { replace: true });
          } else if (payload.user.is_admin) {
            navigate(ADMIN_DASHBOARD_PATH, { replace: true });
          } else {
            navigate(ACCUEIL_PATH, { replace: true });
          }

          toast.success(payload.message, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        } else {
          throw new Error("Réponse SSO invalide");
        }
      })
      .catch((error) => {
        // console.error("Erreur lors du callback SSO:", error);
        toast.error(error.message || "Erreur lors de la connexion SSO", {
          position: "top-right",
          autoClose: 5000,
          theme: "colored",
        });
        navigate("/login", { replace: true });
      })
      .finally(() => setLoading(false));
  }, [location.search, navigate, dispatch]);

  if (loading) {
    return <DisplayLoading />;
  }
  return <DisplayData data={data} />;
};

function DisplayLoading() {
  return (
    <div className="flex flex-col justify-center items-center h-[100vh]">
      <Loader color="#030303" size={24} />
      <h1 className="text-4xl mt-2">En cours de redirection</h1>
    </div>
  );
}

function DisplayData(data) {
  return (
    <div>
      <samp>{JSON.stringify(data, null, 2)}</samp>
    </div>
  );
}

export default BakeliCallback;
